// Study Style Options
export const StudyStyle = {
  QUIET: 'Quiet/Focused',
  COLLABORATIVE: 'Collaborative/Discussing',
  TEACHING: 'Teaching/Explaining',
  PRACTICE: 'Practice Problems'
};

// Study Environment Options
export const StudyEnvironment = {
  SILENT: 'Silent Library',
  COFFEE_SHOP: 'Social Cafe',
  OUTDOOR: 'Outdoor/Park',
  VIRTUAL: 'Virtual/Online'
};

// Time Preference Options
export const TimePreference = {
  MORNING: 'Early Bird',
  AFTERNOON: 'Afternoon',
  EVENING: 'Evening',
  NIGHT: 'Night Owl'
};

// Buddy Role Options
export const BuddyRole = {
  MENTOR: 'Mentor (I can help)',
  LEARNER: 'Learner (I need help)',
  PEER: 'Peer (Equal level)',
  ACCOUNTABILITY: 'Accountability (Just stay focused)'
};

// Group Size Preferences
export const GroupSize = {
  SMALL: 'Small (2-3)',
  MEDIUM: 'Medium (6-7)',
  LARGE: 'Large (10+)'
};

// Session Type Options
export const SessionType = {
  PUBLIC: 'Public',
  PRIVATE: 'Private'
};